import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, LinearProgress } from '@material-ui/core';
import { connect } from 'react-redux';
import * as actions from './store/reportActions';
import { Paper } from '@material-ui/core';
import ReportTableFilter from './ReportTableFilter';
import ReportTable from './ReportTable';
import moment from 'moment/moment.js';

import FilterReport from './FilterReport'

const useStyles = makeStyles(theme => ({
    root: {
        width: `98.8%`,
        height: 'auto',
        paddingTop: theme.spacing(),
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('md')]: {
            padding: 0,
            margin: 0,
            maxWidth: '96%',
            width: '96%',
            marginLeft: '12px',
        },
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            overflow: 'hidden',
            marginLeft: '12px',
            width: '97%'
        }
    },
    progressBarr: {
        width: '100%',
        height: 5
    },
    paperContainer: {
        display: 'flex',
        width: `100%`,
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column'
        }
    },
}))

const ReportIndex = (props) => {
    const { onFetchOrders, onFetchCustomer, onLoadReport, onGetColumns, onFetchTransportColli, onLoadUser, onFetchColli, activeCustomer, translations, report } = props;
    const classes = useStyles();
    const [customer, setCustomer] = useState({ customer: [], order: [], transportColli: [], storage: [], users: [] });
    const [date, setDate] = useState({ dayStart: moment().subtract(7, 'days').startOf('day').format('MM-DD-YYYY'), dayEnd: moment().format('MM-DD-YYYY'), type: 'day' });
    const [loading, setLoading] = useState(false);

    const [load, setLoad] = useState(true);
    useEffect(() => {
        const handleData = async () => {
            setCustomer({ customer: [], order: [], transportColli: [], storage: [], users: [] });
            let orders = await onFetchOrders({ ActiveCustomerID: activeCustomer });
            let customers = await onFetchCustomer({ ActiveCustomerID: activeCustomer });
            let transportCollies = await onFetchTransportColli({ ActiveCustomerID: activeCustomer });
            let storages = await onFetchColli({ ActiveCustomerID: activeCustomer });
            let users = await onLoadUser({ ActiveCustomerID: activeCustomer });
            setCustomer({ customer: customers.list, order: orders.list, transportColli: transportCollies.list, storage: storages.list, users: users.list });
            setLoad(false);
        };
        handleData();
    }, [onFetchCustomer, onFetchTransportColli, onFetchOrders, onFetchColli, onLoadUser, activeCustomer]);
    return (
        <div className={classes.root}>
            <div className={classes.progressBarr}> {loading ? <LinearProgress style={{ marginRight: '8px' }} color="primary" /> : null}
            </div>
            <Grid container direction="row">
                <Paper className={classes.paperContainer}>
                    <Grid key='filter-report' item xs={12} md={12} lg={3}>
                        <FilterReport translations={translations} date={date} activeCustomer={activeCustomer} load={load} onGetColumns={onGetColumns} setLoad={setLoading} onLoadReport={onLoadReport} setDate={setDate} data={customer} />
                    </Grid>
                    <Grid key='filter-report-table' item xs={12} md={12} lg={9}>
                        <ReportTableFilter translations={translations} onGetColumns={props.onGetColumns} setDate={setDate} date={date}></ReportTableFilter>
                        <ReportTable translations={translations} report={report}  ></ReportTable>
                    </Grid>
                </Paper>
            </Grid>
        </div >
    );
};

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        report: state.statistic.report,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {}

    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchCustomer: (id) => dispatch(actions.loadCustomers(id)),
        onFetchOrders: (id) => dispatch(actions.loadOrders(id)),
        onFetchTransportColli: (id) => dispatch(actions.loadTransportCollies(id)),
        onFetchColli: (id) => dispatch(actions.loadCollies(id)),
        onLoadUser: (id) => dispatch(actions.loadUsers(id)),
        onLoadReport: (data, day) => dispatch(actions.listStatisticReport(data, day)),
        onGetColumns: (data) => dispatch(actions.GetColumns(data))
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReportIndex);